// extracted by mini-css-extract-plugin
export default {"indicator":"CustomIndicator_indicator__kum-C"};